export const quickbooksCancelButtonSx = {
  backgroundColor: "#fff",
  border: "1px solid #d32f2f",
  color: "#d32f2f",
  "&:hover": {
    backgroundColor: "#fff5f5",
    borderColor: "#c62828",
    color: "#c62828",
  },
} as const;
